import React from 'react';
import { renderComponent, branch,
  compose, withState, withHandlers,
  withProps, withStateHandlers,
} from 'recompose';
import InputField from '../Common/InputField';
import config from '../../config';
import SupportEmail from '../Common/Helpers/SupportEmail';
import { withTranslationProvider, HTMLTrans } from '../Common/Translations';

const ModalBodyContent = ({ email, onEmailChange, onSubmit, t }) => {
  return (
    <div>
      <InputField
          id={'forgot-password-email'}
          label={t('navbar.auth_forgotpassword_email_label', 'Your Email:')}
          type='email'
          placeholder={t('navbar.auth_forgotpassword_email_placeholder', 'Email')}
          value={email}
          onChange={onEmailChange}
          required
          formClass='form-group mb-5'
          labelClass='ProximaNova-Bold'
          {...!email && { invalidFeedback: t('navbar.auth_forgotpassword_invalid_feedback_email', 'Please fill in your email.') }}
        />
      <button
          type="button"
          onClick={onSubmit}
          className="btn btn-lg btn-block btn-primary"
          id="resetPasswordButton"><HTMLTrans id='navbar.auth_forgotpassword_submit_button'>SUBMIT</HTMLTrans></button>
    </div>
  );
};

const ForgotPassword = (WrappedComp) => {
  return (props) => {
    const {
      submissionValid,
      onLoginClick,
      onRegisterClick,
    } = props;

    return (
      <div className={`${!submissionValid ? 'was-validated' : ''} card border-0'`}>
        <div className="modal-header">
          <h3 className="text-primary font-weight-bold"><HTMLTrans id='navbar.auth_forgotpassword_title'>Forgot Password</HTMLTrans></h3>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body pt-0">
          <WrappedComp {...props} />
        </div>
        <div className="modal-footer text-center">
            <div className="form-footer">
              <p><HTMLTrans id='navbar.auth_forgotpassword_contact_email'>If you have a different problem accessing your account, please contact us at</HTMLTrans> <SupportEmail/></p>
              <p><a href="#" className="mr-2 text-secondary" onClick={onLoginClick}><u><HTMLTrans id='navbar.auth_forgotpassword_login_link'>Login</HTMLTrans></u></a>
                | <a href="#" className="ml-2 text-secondary" onClick={onRegisterClick}><u><HTMLTrans id='navbar.auth_forgotpassword_create_account_link'>Create an
                  account</HTMLTrans></u></a></p>
            </div>
          </div>
      </div>
    );
  };
};

const forgotPassword = props => (value) => {
  const o = { email: value };
  $.post(`${config.localeApi}/forgotpassword`, o)
    .done((response) => {
      props.setSuccessMessage(props.t('navbar.auth_forgotpassword_setsuccessmessage', `An email will be sent to ${response.data} with instructions to reset your password`, {"email": response.data}));
      props.setSubmitted(true);
    })
    .fail((response) => {
      const error = response.responseJSON.errors.email[0];
      toastr.error(
        error, '',
        { positionClass: 'toast-bottom-full-width' },
      );
    });
};

const toRegister = ({ ...props }) => (event) => {
  event.preventDefault();
  if (props.updateFormState) {
    props.updateFormState('register');
  } else {
    props.router.push(props.tRoute('/account/register'));
  }
};

const toLogin = ({ ...props }) => (event) => {
  event.preventDefault();
  if (props.updateFormState) {
    props.updateFormState('login');
  } else {
    props.router.push(props.tRoute('/account/login'));
  }
};

const SuccessMessage = (props) => {
  return (
    <h3>{props.successMessage}</h3>
  );
};

const Container = ForgotPassword(ModalBodyContent);

const hasSubmittedRequest = branch(
  props => props.isSubmitted,
  renderComponent(ForgotPassword(SuccessMessage)),
);

export const withForgotPasswordProps = compose(
  withStateHandlers(({
    email = '',
  }) => ({
    email,
  }), {
    onEmailChange: () => ({ target }) => ({ email: target.value }),
  }),
  withState('submissionValid', 'setSubmissionValid', true),
  withState('isSubmitted', 'setSubmitted', false),
  withState('successMessage', 'setSuccessMessage', ''),
  withHandlers({
    onSubmit: ({ email, setSubmissionValid, ...props }) => (event) => {
      event.preventDefault(event);
      setSubmissionValid(false);
      forgotPassword(props)(email);
    },
  }),
);

const enhance = compose(
  withTranslationProvider,
  withProps(({ ...props }) => {
    return {
      onLoginClick: toLogin(props),
      onRegisterClick: toRegister(props),
    };
  }),
  withTranslationProvider,
  withForgotPasswordProps,
  hasSubmittedRequest,
)(Container);

export default enhance;
export const undecorated = Container;



// WEBPACK FOOTER //
// ./src/Auth/ForgotPassword.js